/**
 * `localStorage` key that the retargeting helper writes to and that the
 * homepage retargeting reader (and any future consumer of the same store)
 * must read from.
 *
 * Exported so consumers reference the single source of truth instead of
 * hard-coding the literal. Treat changes to this value as a breaking change
 * to the cross-team contract.
 */
export const STORAGE_KEY = 'miRetargetingCandidates';

export const SCHEMA_VERSION = 1 as const;
export const MAX_ENTRIES = 10 as const;

/**
 * Canonical string values for the `useCase` discriminant.
 *
 * Reference these instead of hard-coding `'reslink'`, `'rlm'`, or `'hws'` in
 * runtime comparisons so a typo becomes a compile error rather than a silent
 * "unknown use case" failure at runtime. Retargeting input and stored types
 * derive their discriminants from these values.
 */
export const RESLINK = 'reslink' as const;
export const RLM = 'rlm' as const;
export const HWS = 'hws' as const;
